const IMAGE_EXTENSIONS = new Set([
  "jpg",
  "jpeg",
  "png",
  "gif",
  "webp",
  "bmp",
  "tiff",
  "svg",
  "heic",
  "heif",
]);

export function getFileExtension(fileName: string): string {
  const parts = fileName.split(".");
  return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : "";
}

export function isImageContentType(contentType?: string): boolean {
  if (!contentType) return false;
  return contentType === "image" || contentType.startsWith("image/");
}

export function isImageFile(
  fileName: string,
  contentType?: string,
  options?: { assumeImage?: boolean },
): boolean {
  if (isImageContentType(contentType)) return true;
  if (options?.assumeImage) return true;

  const extension = getFileExtension(fileName);
  return IMAGE_EXTENSIONS.has(extension);
}

export function inferContentTypeFromFileName(fileName: string): string {
  const extension = getFileExtension(fileName);
  const mimeMap: Record<string, string> = {
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    png: "image/png",
    gif: "image/gif",
    webp: "image/webp",
    heic: "image/heic",
    heif: "image/heif",
    bmp: "image/bmp",
    svg: "image/svg+xml",
    tiff: "image/tiff",
    txt: "text/plain",
    md: "text/markdown",
    json: "application/json",
  };

  return mimeMap[extension] || "";
}

export function inferImageContentType(file: File): string {
  if (file.type && file.type.startsWith("image/")) {
    return file.type;
  }

  const extension = getFileExtension(file.name);
  const mimeMap: Record<string, string> = {
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    png: "image/png",
    gif: "image/gif",
    webp: "image/webp",
    heic: "image/heic",
    heif: "image/heif",
    bmp: "image/bmp",
    svg: "image/svg+xml",
    tiff: "image/tiff",
  };

  return mimeMap[extension] || "image/jpeg";
}
